import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import {
  MESSAGE_DIFFUSION_USERS_ADDED,
  MESSAGE_DIFFUSION_OPEN_MODAL,
  MESSAGE_DIFFUSION_CLOSE_MODAL,
  MESSAGE_DIFFUSION_CLEAR_USERS,
} from '../actions/diffusion';

const initialState = {
  modalOpened: false,
  selectedUsers: Map(),
};

const diffusion = createReducer(initialState, {
  [MESSAGE_DIFFUSION_USERS_ADDED](state, { users }) {
    const newState = {
      ...state,
      selectedUsers: state.selectedUsers.merge(users),
      modalOpened: false,
    };
    return newState;
  },
  [MESSAGE_DIFFUSION_OPEN_MODAL](state, action) {
    return {
      ...state,
      modalOpened: true,
    };
  },
  [MESSAGE_DIFFUSION_CLOSE_MODAL](state, action) {
    return {
      ...state,
      modalOpened: false,
    };
  },
  [MESSAGE_DIFFUSION_CLEAR_USERS](state, action) {
    return {
      ...state,
      selectedUsers: Map(),
    };
  },
});

export const getSelectedUsers = state => {
  return state.messaging.diffusion.selectedUsers.toArray();
};

export const isModalOpened = state => {
  return state.messaging.diffusion.modalOpened;
};

export default diffusion;



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/diffusion.js